export default {"src":"/_next/static/media/blue-heart.fb79515d.svg","height":19,"width":21,"blurWidth":0,"blurHeight":0};